import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35c347b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

import { PropType, computed, ref } from "vue";
import { ContextMenuItem } from "../../../types/ui/menus/ContextMenuItem";
import { DxContextMenu } from "devextreme-vue/context-menu";
import { DxButton } from "devextreme-vue/button";


export default /*#__PURE__*/_defineComponent({
  __name: 'grid-menu',
  props: {
  /**
   * The menu items to be displayed in the dropdown menu.
   * @type {ContextMenuItem[]}
   * @required
   */
  menuItems: {
    type: Array as PropType<ContextMenuItem[]>,
    required: true,
  },
  /**
   * Determines whether the item should be disabled.
   * @type {boolean}
   * @default false
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * The unique identifier for the current item.
   * @type {string}
   * @default 'grid-menu-button'
   */
  id: {
    type: String,
    default: "grid-menu-button",
  },
  /**
   * The icon displayed on the button.
   * @type {string}
   * @default 'fas fa-bars'
   */
  buttonIcon: {
    type: String,
    default: "fas fa-bars",
  },
  /**
   * The text displayed on the button.
   * @type {string}
   * @default ''
   */
  buttonText: {
    type: String,
    default: "",
  },
  /**
   * The position of the menu button relative to the component.
   * @type {string}
   * @default 'top right'
   */
  myPosition: {
    type: String,
    default: "top right",
  },
  /**
   * The position of the dropdown menu relative to the button.
   * @type {string}
   * @default 'bottom right'
   */
  atPosition: {
    type: String,
    default: "bottom right",
  },
},
  emits: ["itemClicked"],
  setup(__props, { emit }) {

const props = __props;



const menuPosition = computed(() => {
  const isMobile = window.innerWidth < 768;
  return {
    my: isMobile ? "left top" : props.myPosition,
    at: isMobile ? "left bottom" : props.atPosition,
    collision: "fit flip",
  };
});



const showMenu = ref(false);

/** Handles the menu button click event to show the context menu */
const onMenuButtonClick = () => (showMenu.value = !showMenu.value);

/** Handles the menu item click event */
const onMenuItemClick = (e: any) => {
  emit("itemClicked", e.itemData.key);
};

const onItemRendered = (e: any) => {
  if (e.itemData.cssClass) {
    e.itemElement.classList.add(...e.itemData.cssClass.split(" "));
  }
};

const buttonClass = computed(() =>
  !props.buttonIcon && props.buttonText ? "text-button" : "",
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: __props.id }, [
    _createVNode(_unref(DxButton), {
      class: _normalizeClass(buttonClass.value),
      icon: __props.buttonIcon,
      onClick: onMenuButtonClick,
      disabled: __props.disabled,
      text: __props.buttonText
    }, null, 8, ["class", "icon", "disabled", "text"]),
    _createVNode(_unref(DxContextMenu), {
      visible: showMenu.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showMenu).value = $event)),
      "data-source": __props.menuItems,
      target: `#${__props.id}`,
      position: menuPosition.value,
      onItemClick: onMenuItemClick,
      onItemRendered: onItemRendered
    }, null, 8, ["visible", "data-source", "target", "position"])
  ], 8, _hoisted_1))
}
}

})